import { MatDialogRef } from '@angular/material';
import { Component } from '@angular/core';

@Component({
    template: `
        <h3 style="margin-top:0">{{ title }}</h3>
        <p  [innerHTML]="message" style="margin-bottom: 30px"></p>
        <button type="button" mat-raised-button color="primary" style="margin-right: 10px"
            (click)="dialogRef.close(true)">OK</button>
        <button type="button" mat-button mat-raised-button
            (click)="dialogRef.close()">Cancel</button>
    `,
})
export class ConfirmDialogComponent {

    public title: string;
    public message: string;

    constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>) {

    }
}
